import { ReactElement } from 'react'
import styled from 'styled-components'
import { Price } from '../../../../../src/ui-components/products/Price'
import { Price as PriceType } from 'interfaces'
import { breakpoints } from '../../../../../src/theme/breakpoints'

interface IOtherPricesProps {
  item: PriceType
  isCondensedView?: boolean
}

const OtherPrices = ({
  item,
  isCondensedView,
}: IOtherPricesProps): ReactElement => (
  <OtherPricesCell isCondensedView={isCondensedView}>
    <PriceWrapper>
      <PriceCodeWrapper isCondensedView={isCondensedView}>
        <NoWrap>
          <b>{item?.priceCodeName}</b>
        </NoWrap>
      </PriceCodeWrapper>
      <PriceSubCell>
        <BigPrice isCondensedView={isCondensedView}>
          <Price num={item?.priceValue} />
        </BigPrice>
        <br />
      </PriceSubCell>
    </PriceWrapper>
  </OtherPricesCell>
)

interface IsCondensedViewProps {
  isCondensedView?: boolean
}

const BigPrice = styled.span<IsCondensedViewProps>`
  font-size: ${(p) => (p.isCondensedView ? '14px' : '20px')};
  font-weight: bold;
  font-family: Roboto, serif;
`

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
  line-height: 24px;
  text-align: start;
`

const OtherPricesCell = styled(Cell)<IsCondensedViewProps>`
  width: 100%;
`
const PriceWrapper = styled.div`
  display: flex;
  width: 100%;

  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    column-gap: 136px;
  }
`
const NoWrap = styled.span`
  white-space: nowrap;
`
const PriceSubCell = styled.span`
  text-align: left;
  flex: 1;
`

const PriceCodeWrapper = styled.span<IsCondensedViewProps>`
  font-size: ${(p) => p.isCondensedView && '14px'};
  flex: 1;
`

export default OtherPrices
